import {useClientStorage, useRubricArticleStore} from "@/stores/store";
import {LS} from "@/shared/services/translate";
import {
    CONST_ARTICLE_PATH,
    CONST_FILTERED_ARTICLES_PATH,
    CONST_RUBRIC_PATH,
    DEFAULT_LANGUAGE_CODE
} from "@/shared/constants/consts";
import {storeToRefs} from "pinia";

export const getFilteredArticles = (rubrics, articles, filter_text, limit = -1) => {
    let filtered_articles = [];

    if(!Object.keys(articles).length)
        return filtered_articles;

    const lang = useClientStorage().clientObj.lang;

    for (let i in articles)
    {
        let articleObj = articles[i];

        if(
            filter_text &&
            filter_text.length &&
            Object.prototype.hasOwnProperty.call(articleObj.content_lang, lang) &&
            articleObj.content_lang[lang].status == 1 &&
            articleObj.content_lang[lang].title.toLowerCase().indexOf(filter_text.toLowerCase()) !== -1
        )
        {
            let rubricObj = getRubricById(rubrics, articleObj.rubric_id);

            if(rubricObj != null) {
                filtered_articles.push({
                    id: articleObj.id,
                    rubric_id: articleObj.rubric_id,
                    rubric_name: rubricObj.name,
                    title: articleObj.content_lang[lang].title
                });
            }
        }

        if(limit !== -1 && filtered_articles.length >= limit)
            break;
    }

    return filtered_articles;
}

export const getRubricById = (rubrics, rubric_id) => {

    for (let i in rubrics)
    {
        let rubricObj = rubrics[i];

        if(rubricObj.id == rubric_id) {
            return rubricObj;
        }
    }

    return null;
}

export const getArticleById = (articles, rubric_id, article_id) => {

    let articleObj = null;
    for (let i in articles)
    {
        let articleObj = articles[i];

        if(articleObj.rubric_id == rubric_id && articleObj.id == article_id) {
            return articleObj;
        }
    }

    return articleObj;
}

export const UpdateTitleAndMeta = (to) => {
    const rubricArticleStore = useRubricArticleStore();
    const { nav_rubric_name, nav_article_name, article } = storeToRefs(rubricArticleStore);

    const clientStorage = useClientStorage();
    const lang = clientStorage.clientObj.lang;

    let document_title = LS("База знаний");

    if(to.path === CONST_RUBRIC_PATH) {
        document_title = nav_rubric_name.value;
    }
    else if (to.path === CONST_ARTICLE_PATH) {
        document_title = nav_article_name.value;

        let meta_title = LS("PuzzleBot :// База знаний");
        let meta_text = LS("База знаний");
        let meta_image = 'https://i.imgur.com/Z3qrZPX.jpg';
        let meta_url = window.location.href;
        let meta_date = new Date().toJSON();

        if(article.value != null)
        {
            let result_lang = DEFAULT_LANGUAGE_CODE;

            if(Object.prototype.hasOwnProperty.call(article.value.content_lang, lang))
                result_lang = lang;

            meta_title = article.value.content_lang[result_lang].title;
            meta_text = article.value.content_lang[result_lang].meta_text;
            meta_date = new Date(article.value.date).toJSON();

            if(meta_text != null && meta_text.match(/<img src="([^ ]*)">/))
            {
                const matches = meta_text.match(/<img src="([^ ]*)">/)
                meta_image = matches[1];
            }
        }

        const meta_data = [{
            'name' : 'description',
            'content' : meta_text,
        },{
            'name' : 'zen_image',
            'content' : meta_image,
        },{
            'property' : 'og:url',
            'content' : meta_url,
        },{
            'property' : 'og:title',
            'content' : meta_title,
        },{
            'property' : 'og:description',
            'content' : meta_text,
        },{
            'property' : 'og:image',
            'content' : meta_url,
        },{
            'property' : 'og:image:secure_url',
            'content' : meta_url,
        },{
            'property' : 'og:image:type',
            'content' : 'image/jpg',
        },{
            'property' : 'og:image:width',
            'content' : '720',
        },{
            'property' : 'og:image:height',
            'content' : '382',
        },{
            'property' : 'og:site_name',
            'content' : 'PuzzleBot ://',
        },{
            'property' : 'og:updated_time',
            'content' : meta_date,
        },{
            'property' : 'vk:page_id',
            'content' : 177922383,
        },{
            'property' : 'vk:image',
            'content' : meta_image,
        },{
            'name' : 'twitter:card',
            'content' : 'summary_large_image',
        },{
            'name' : 'twitter:title',
            'content' : meta_title,
        },{
            'name' : 'twitter:description',
            'content' : meta_text,
        },{
            'name' : 'twitter:image',
            'content' : meta_image,
        },{
            'name' : 'twitter:description',
            'content' : meta_text,
        },{
            'name' : 'twitter:site',
            'content' : '@iampuzzlebot',
        },{
            'name' : 'twitter:creator',
            'content' : '@iampuzzlebot',
        },{
            'property' : 'article:publisher',
            'content' : 'https://facebook.com/iampuzzlebot',
        },{
            'property' : 'article:published_time',
            'content' : meta_date,
        },{
            'property' : 'article:modified_time',
            'content' : meta_date,
        },{
            'property' : 'article:tag',
            'content' : meta_date,
        },{
            'property' : 'article:modified_time',
            'content' : LS("конструктор чат-ботов"),
        },{
            'property' : 'format-detection',
            'content' : 'telephone=no',
        }
        ]

        document.querySelectorAll("meta.data-vue-router-controlled").forEach(e => e.remove());

        meta_data.map(tagDef => {
            const tag = document.createElement('meta');
            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key]);
            });
            tag.classList.add("data-vue-router-controlled");
            return tag;
        })
            .forEach(tag => document.head.appendChild(tag));

    }
    else if (to.path === CONST_FILTERED_ARTICLES_PATH) {
        document_title = LS("Результат поиска");
    }

    document.title = document_title;

    return true;
}